import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommercialDocumentType } from '../models/commercial-document-type';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommercialDocumentTypeService {

  constructor(private http: HttpClient) { }

  getDocumentTypes(): Observable<CommercialDocumentType[]>{
    return this.http.get<CommercialDocumentType[]>('/api/get/document-type');
  }

  getDocumentTypeByTravelID(travel_id: number){
    return this.http.get<CommercialDocumentType[]>('/api/get/document-type/travel-id', {params:{'travel_id': JSON.stringify(travel_id)}});
  }
}
